export const CLEAR_ORG_PODCASTS = 'CLEAR_ORG_PODCASTS'
export const CLEAR_USER_INVITES = 'CLEAR_USER_INVITES'
export const SET_USER = 'SET_USER'
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES'
export const FETCHING_USER = 'FETCHING_USER'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_ACCOUNT_API_KEY = 'SET_ACCOUNT_API_KEY'
export const SET_AUTHORIZED_APPS = 'SET_AUTHORIZED_APPS'
export const SET_ACCOUNT_NAV = 'SET_ACCOUNT_NAV'
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT'
export const SET_ORG_PODCASTS = 'SET_ORG_PODCASTS'
export const SET_ORG_PODCASTS_COUNT = 'SET_ORG_PODCASTS_COUNT'
export const SET_ORG_PODCASTS_TOTAL = 'SET_ORG_PODCASTS_TOTAL'
export const SET_USER_INVITES = 'SET_USER_INVITES'
export const UPDATE_ERROR = 'UPDATE_ERROR'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_PRIVATE_APPS = 'SET_PRIVATE_APPS'
export const SET_TWO_FACTOR = 'SET_TWO_FACTOR'
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'
